import React from 'react';
import { Copy, CheckCircle } from 'lucide-react';

const AddressDisplay = ({ 
  address, 
  chain,
  copied,
  onCopy,
  isMobile = false,
  label = 'Address'
}) => {
  if (isMobile) {
    return (
      <div style={{
        backgroundColor: '#0b0e11',
        borderRadius: '8px',
        padding: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}>
        <div style={{ 
          flex: 1, 
          fontSize: '10px', 
          color: '#eaecef', 
          wordBreak: 'break-all', 
          fontFamily: 'monospace' 
        }}>
          {address}
        </div>
        <button
          onClick={() => onCopy(address)}
          style={{
            padding: '8px 12px',
            backgroundColor: '#f0b90b',
            color: '#000',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            fontSize: '11px',
            fontWeight: '600',
          }}
        >
          {copied ? <CheckCircle size={14} /> : <Copy size={14} />}
        </button>
      </div>
    );
  }

  // Desktop version
  return (
    <div style={{
      padding: '16px',
      backgroundColor: '#181a20',
      border: '1px solid #2b3139',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    }}>
      <div style={{ flex: 1, fontSize: '13px', color: '#eaecef', wordBreak: 'break-all', fontFamily: 'monospace' }}>
        {address}
      </div>
      <button
        onClick={() => onCopy(address)}
        style={{
          padding: '8px 16px',
          backgroundColor: '#f0b90b',
          color: '#000',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '13px',
          fontWeight: '600',
        }}
      >
        {copied ? <CheckCircle size={16} /> : <Copy size={16} />}
        {copied ? 'Copied' : 'Copy'}
      </button>
    </div>
  );
};

export default AddressDisplay;
